module.exports = __webpack_public_path__ + "img/C1.968409b5.png";